import { render, staticRenderFns } from "./arrows.vue?vue&type=template&id=4a7af928&scoped=true&"
var script = {}
import style0 from "./arrows.vue?vue&type=style&index=0&id=4a7af928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7af928",
  null
  
)

export default component.exports